<template lang="html">
  <div class="auth-form-transparent text-left p-3">
    <div class="brand-logo">
      <img src="/img/logo.png" alt="logo"> TradingAmmo
    </div>
    <h6>{{lang=="ru"?"Пожалуйста, перейдите по ссылке, чтобы подтвердить свой адрес электронной почты":"Please follow the link on your mail to confirm account"}}👌</h6>
    <h6>{{lang=="ru"?"Предлагаем Вам подробнее ознакомиться с платформой:":""}}</h6>
    <a v-if="lang=='ru'" href="https://youtu.be/uzF_UMmWgio">https://youtu.be/uzF_UMmWgio</a>
  </div>
</template>

<script>
export default {
  data () {
    return {
      lang:'en'
    }
  },
  created(){
    this.lang = this.$cookie.get('lang');
  }
}
</script>

<style lang="css" scoped>
  .card{
    box-shadow: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/VerifyMail.vue